import React, { useEffect } from 'react';
import { Grid, Button, Typography } from '@mui/material';
import { Navigate, useSearchParams, useNavigate } from 'react-router-dom';

import { isAuthenticated } from '../utils/auth';
import { ROOTINE_APP_URL } from '../config';
import { Loading } from '../components';
import useAPI from '../utils/useApi';
import { APIRequests } from '../config/api';
import userServices from '../utils/user';

export const Verify = (): JSX.Element => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = { recordid: params.get('token') };
  const mobile = params.get('mobile');

  if (!token) {
    navigate('/login');
  }

  const verifyRequest = useAPI(APIRequests.Verify);
  useEffect(() => {
    // if the user has the app installed, they will be prompted to open the app
    if (mobile) {
      window.location.replace(
        `com.rootine.rootine://my.rootine.co/verify?token=${params.get(
          'token'
        )}`
      );
    } else {
      verifyRequest.execute({ body: token });
    }
  }, []);

  useEffect(() => {
    if (verifyRequest.data) {
      const d = verifyRequest.data;
      //@ts-ignore
      userServices.setCookie('rootine_jwt', d['access_token'], 15);
      //@ts-ignore
      userServices.setCookie('rootine_email', d['email'], 15);
      //@ts-ignore
      userServices.setCookie('rootine_name', d['name'], 15);
      //@ts-ignore
      userServices.setCookie('rootine_id', d['id'], 15);
      navigate('/dashboard');
    } else if (verifyRequest.error) {
      // navigate('/login');
    }
  }, [verifyRequest.data, verifyRequest.error]);

  return isAuthenticated() ? (
    <Navigate to="/dashboard" />
  ) : (
    <>
      <Grid
        container
        spacing={2}
        alignItems="flex-end"
        sx={{
          px: { xs: 2, sm: 10, md: 20, lg: 40, xl: 60 },
          paddingTop: { sm: 20 },
        }}
      >
        <Grid item xs={12} container justifyContent="center">
          <img
            src="/images/logo_black.svg"
            alt="logo"
            style={{ margin: 25 }}
          />
        </Grid>
        <Grid item xs={12} container justifyContent="center" textAlign="center">
          {mobile ? (
            <Typography>
              To login to your Rootine mobile app, you must open this link in
              your mobile web browser. Then press "Open" when prompted to open
              the Rootine app.
            </Typography>
          ) : (
            <Loading />
          )}
        </Grid>
        <Grid item xs={12} container justifyContent="center" textAlign="center">
          <Button
            disableFocusRipple
            disableRipple
            variant="text"
            onClick={() => (window.location.href = `${ROOTINE_APP_URL}/quiz`)}
          >
            No Account? Create a profile now
          </Button>
        </Grid>
      </Grid>
    </>
  );
};
